import { Component, Input, OnInit } from '@angular/core';
import { WorkflowService } from '../../services/workflow-service';
import { BaseComponent } from '../../../../shared/components/component-base';
import { MainRequestDetailsDto } from '../../model/main-request-details.dto';
import { ApiResponse } from '../../../../shared/models/api-response.model';

@Component({
  selector: 'main-request-details',
  templateUrl: './main-request-details.component.html',
})
export class MainRequestDetailsComponent extends BaseComponent implements OnInit {
  @Input() requestId: string;
  requestDetails?: MainRequestDetailsDto;

  constructor(public _workflowService?: WorkflowService) {
    super();
  }

   ngOnInit() {
    this.getRequestDetails();
  }

  getRequestDetails() {
    if (this.requestId) {
      this._workflowService.getMainRequestDetails(this.requestId).subscribe({
        next: (res: ApiResponse<MainRequestDetailsDto>) => {
          this.requestDetails = res.value;
        },
        error: (error: Error) => { },
      });
    }
  }

}
